exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".FAQ .faq-list {\n  padding-left: 20px;\n}\n.FAQ .faq-list > .faq-list__item:nth-child(odd) {\n  list-style-type: \"Q: \";\n  margin-bottom: 5px;\n}\n.FAQ .faq-list > .faq-list__item:nth-child(even) {\n  list-style-type: \"A: \";\n  margin-bottom: 15px;\n}\n", ""]);

